export default __webpack_public_path__ + "5381fe4b3c7cdc94fd9c4fe6e90eb8e2.svg";